import React from 'react'
import { HeaderWithBulletPoints } from '@chegg-wt/core/types/core'
import { LOW_AD_VARIATION3 } from '@chegg-wt/core/state/optimizely/constants'
import { LvpMarginWrapper, useLvpContext } from '../Layouts/LargeVideoPlayerLayout'
import * as Styled from './styled'

interface CMSContentProps {
  copy: HeaderWithBulletPoints[]
}

const CMSContent: React.FC<CMSContentProps> = ({ copy }) => {
  const { adConfigVersion } = useLvpContext()
  const isHrCenterAlign = adConfigVersion === LOW_AD_VARIATION3
  return (
    <Styled.Container className="cms-content results">
      <LvpMarginWrapper>
        <Styled.Wrapper layoutHRCenter={isHrCenterAlign}>
          <div className="container-fluid" id="content-addition">
            <div className="row">
              {copy.map(({ header, body }) => (
                <Styled.CMSContentBox>
                  <Styled.ContentContainer>
                    <Styled.ContentHeader>{header}</Styled.ContentHeader>
                    {body.map((paragraph) => (
                      <Styled.P>{paragraph}</Styled.P>
                    ))}
                  </Styled.ContentContainer>
                </Styled.CMSContentBox>
              ))}
            </div>
          </div>
        </Styled.Wrapper>
      </LvpMarginWrapper>
    </Styled.Container>
  )
}

export default CMSContent
